import * as React from 'react';

import moment from 'moment';

import {Checkbox} from 'shells/checkbox/checkbox';
// @ts-expect-error
import {DateTimeInputTextfield} from 'shells/date-time-picker/date-time-input-textfield';
import {FormField} from 'shells/form/form-field';

import styles from './activity-times-new.module.css';

const ALL_DAY_DISPLAY_FORMAT = 'MMM Do, YYYY';
const DEFAULT_DISPLAY_FORMAT = 'MMM Do, YYYY [at] h:mm A';

type DateValue = {
    isAllDay?: boolean;
    startTime: Date;
    endTime: Date;
};

type Props = {
    input: {
        value: DateValue;
        onChange: (newValue: DateValue) => any;
    };
    isRequired?: boolean;
};

export function ActivityTimesNew(props: Props) {
    const displayFormat = props.input.value.isAllDay
        ? ALL_DAY_DISPLAY_FORMAT
        : DEFAULT_DISPLAY_FORMAT;

    const handleChangeIsAllDay = (isChecked: boolean) => {
        const value = {
            ...props.input.value,
            isAllDay: isChecked,
        } as const;

        props.input.onChange(value);
    };

    const handleChangeStartTime = (startTime: Date) => {
        const updatedStartTime = props.input.value.isAllDay
            ? moment(startTime).startOf('day').toDate()
            : startTime;

        const updatedEndTime =
            updatedStartTime > props.input.value.endTime
                ? moment(updatedStartTime).add(15, 'minutes').toDate()
                : props.input.value.endTime;

        props.input.onChange({
            ...props.input.value,
            startTime: updatedStartTime,
            endTime: updatedEndTime,
        });
    };

    const handleChangeEndTime = (endTime: Date) => {
        const updatedEndTime = props.input.value.isAllDay
            ? moment(endTime).endOf('day').toDate()
            : endTime;

        const updatedStartTime =
            updatedEndTime < props.input.value.startTime
                ? moment(updatedEndTime).subtract(15, 'minutes').toDate()
                : props.input.value.startTime;

        props.input.onChange({
            ...props.input.value,
            startTime: updatedStartTime,
            endTime: updatedEndTime,
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles['flex-container']}>
                <div className={styles['flex-item']}>
                    <FormField innerId='startTime' label='Start time' isRequired={props.isRequired}>
                        <DateTimeInputTextfield
                            displayFormat={displayFormat}
                            label='Start'
                            name='startTime'
                            value={props.input.value.startTime}
                            onChange={handleChangeStartTime}
                        />
                    </FormField>
                </div>
                <div className={styles['flex-item']}>
                    <FormField innerId='endTime' label='End time' isRequired={props.isRequired}>
                        <DateTimeInputTextfield
                            displayFormat={displayFormat}
                            label='End'
                            name='endTime'
                            value={props.input.value.endTime}
                            onChange={handleChangeEndTime}
                        />
                    </FormField>
                </div>
            </div>
            <div className={styles['checkbox-container']}>
                <Checkbox
                    label='All day'
                    checked={props.input.value.isAllDay}
                    onChange={handleChangeIsAllDay}
                />
            </div>
        </div>
    );
}
